import {MapAnnouncement} from "./MapAnnouncement";

export class MapUpdate extends MapAnnouncement {

    constructor(map_id: string) {
        super(map_id, 'update', null);
    }

    static fromRaw(map_id: string, value: any): MapUpdate {
        return new MapUpdate(map_id);
    }

}
